import { render } from "./CookieNotice.vue?vue&type=template&id=5ca95914&scoped=true"
import script from "./CookieNotice.vue?vue&type=script&lang=js"
export * from "./CookieNotice.vue?vue&type=script&lang=js"

import "./CookieNotice.vue?vue&type=style&index=0&id=5ca95914&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca95914"]])

export default __exports__